import type { BonusLootTier } from '@/types/api';

export function rollBonusLoot(tiers: Pick<BonusLootTier, 'rewardAmount' | 'chancePercent'>[]): number {
  if (!tiers.length) return 0;

  const roll = Math.random() * 100;
  let cumulative = 0;

  for (const tier of tiers) {
    cumulative += tier.chancePercent;
    if (roll < cumulative) {
      return tier.rewardAmount;
    }
  }

  return 0;
}
